import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenu = () => setIsMenuOpen(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 glass-card" data-testid="main-header">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-1.5">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-3" onClick={closeMenu}>
            <img 
              src="https://customer-assets.emergentagent.com/job_steel-build-pro/artifacts/imjdxz67_3d-metal-home-building-logo%202.jpg"
              alt="3D Metal Home Building"
              className="h-14 w-auto"
            />
            <span className="text-base font-bold text-white" style={{ fontFamily: 'Rajdhani, sans-serif' }}>
              3D METAL HOME BUILDING
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8 items-center">
            <Link
              to="/"
              className="text-slate-300 hover:text-orange-500 font-medium transition-colors uppercase tracking-wider"
              style={{ fontFamily: 'Rajdhani, sans-serif' }}
              data-testid="nav-home"
            >
              Home
            </Link>
            <Link
              to="/photos"
              className="text-slate-300 hover:text-orange-500 font-medium transition-colors uppercase tracking-wider"
              style={{ fontFamily: 'Rajdhani, sans-serif' }}
              data-testid="nav-photos"
            >
              Photos
            </Link>
            <Link
              to="/info"
              className="text-slate-300 hover:text-orange-500 font-medium transition-colors uppercase tracking-wider"
              style={{ fontFamily: 'Rajdhani, sans-serif' }}
              data-testid="nav-info"
            >
              Info
            </Link>
            <Link
              to="/contact"
              className="text-slate-300 hover:text-orange-500 font-medium transition-colors uppercase tracking-wider"
              style={{ fontFamily: 'Rajdhani, sans-serif' }}
              data-testid="nav-contact"
            >
              Contact
            </Link>
            <Link
              to="/admin"
              className="ml-4 px-6 py-2 border-2 border-orange-500 text-orange-500 hover:bg-orange-500 hover:text-slate-950 font-bold uppercase tracking-wider transition-all duration-300"
              style={{ fontFamily: 'Rajdhani, sans-serif' }}
              data-testid="nav-login"
            >
              Login
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-slate-300 hover:text-orange-500 transition-colors"
            data-testid="mobile-menu-toggle"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="md:hidden mt-4 space-y-4 pb-4" data-testid="mobile-menu">
            <Link
              to="/"
              onClick={closeMenu}
              className="block w-full text-left text-slate-300 hover:text-orange-500 font-medium transition-colors uppercase tracking-wider"
              style={{ fontFamily: 'Rajdhani, sans-serif' }}
              data-testid="mobile-nav-home"
            >
              Home
            </Link>
            <Link
              to="/photos"
              onClick={closeMenu}
              className="block w-full text-left text-slate-300 hover:text-orange-500 font-medium transition-colors uppercase tracking-wider"
              style={{ fontFamily: 'Rajdhani, sans-serif' }}
              data-testid="mobile-nav-photos"
            >
              Photos
            </Link>
            <Link
              to="/info"
              onClick={closeMenu}
              className="block w-full text-left text-slate-300 hover:text-orange-500 font-medium transition-colors uppercase tracking-wider"
              style={{ fontFamily: 'Rajdhani, sans-serif' }}
              data-testid="mobile-nav-info"
            >
              Info
            </Link>
            <Link
              to="/contact"
              onClick={closeMenu}
              className="block w-full text-left text-slate-300 hover:text-orange-500 font-medium transition-colors uppercase tracking-wider"
              style={{ fontFamily: 'Rajdhani, sans-serif' }}
              data-testid="mobile-nav-contact"
            >
              Contact
            </Link>
            <Link
              to="/admin"
              onClick={closeMenu}
              className="block w-full text-center py-2 border-2 border-orange-500 text-orange-500 hover:bg-orange-500 hover:text-slate-950 font-bold uppercase tracking-wider transition-all duration-300"
              style={{ fontFamily: 'Rajdhani, sans-serif' }}
              data-testid="mobile-nav-login"
            >
              Login
            </Link>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
